import {
  GET_NOTIFICATIONS,
  ADD_NOTIFICATION,
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  UPDATE_INVITATION_STATUS,
  NOTIFICATION_ERROR
} from '../actions/types';

const initialState = {
  notifications: [],
  unreadCount: 0,
  loading: true,
  error: {}
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_NOTIFICATIONS:
      return {
        ...state,
        notifications: payload,
        unreadCount: payload.filter(n => !n.read).length,
        loading: false
      };
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [payload, ...state.notifications],
        unreadCount: state.unreadCount + 1,
        loading: false
      };
    case MARK_NOTIFICATION_READ:
      return {
        ...state,
        notifications: state.notifications.map(n => 
          n._id === payload ? { ...n, read: true } : n
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
        loading: false
      };
    case MARK_ALL_NOTIFICATIONS_READ:
      return {
        ...state,
        notifications: state.notifications.map(n => ({ ...n, read: true })),
        unreadCount: 0,
        loading: false
      };
    case UPDATE_INVITATION_STATUS:
      return {
        ...state,
        notifications: state.notifications.map(n => 
          n._id === payload.id ? { ...n, status: payload.status, read: true } : n
        ),
        loading: false
      };
    case NOTIFICATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
